import React from "react";
import { Alert, Box } from "@mui/material";
import { TranslateContext } from "../../context/TranslateContext";
import { useAdminStudio } from "./AdminStudioContext";
import UserDash from "../../user/dashboard/Dash";
import Influencers from "../../user/influencers/Influencers";
import HeyGenActors from "../../user/actors/HeyGenActors";
import Gallery from "../../user/gallery/Gallery";
import ContentComp from "../../user/content/Content";
import ScriptVideo from "../../user/scripVideo/ScriptVideo";
import Voices from "../../user/voices/Voices";
import UgcAdsWorkflow from "../../user/ugcWorkflow/UgcAdsWorkflow";
import VideoAgent from "../../user/videoAgent/VideoAgent";
import MakeUGC from "../../user/makeugc/MakeUGC";
import MusicStudio from "../../user/music/MusicStudio";
import ProductAds from "../../user/productAds/ProductAds";
import Billing from "../../user/billing/Billing";
import Usage from "../../user/usage/Usage";
import Notification from "../../user/notification/Notification";
import Support from "../../user/support/Support";

const STUDIO_PAGES = {
  "studio-dashboard": UserDash,
  "studio-influencers": Influencers,
  "studio-actors": HeyGenActors,
  "studio-gallery": Gallery,
  "studio-content": ContentComp,
  "studio-script-to-video": ScriptVideo,
  "studio-voices": Voices,
  "studio-ugc-workflow": UgcAdsWorkflow,
  "studio-video-agent": VideoAgent,
  "studio-makeugc": MakeUGC,
  "studio-music": MusicStudio,
  "studio-product-ads": ProductAds,
  "studio-billing": Billing,
  "studio-usage": Usage,
  "studio-notifications": Notification,
  "studio-user-help": Support,
};

export default function AdminStudioContent({ selectedMenu }) {
  const { lang } = React.useContext(TranslateContext);
  const { hasStudioSession } = useAdminStudio();
  const Page = STUDIO_PAGES[selectedMenu];

  if (!Page) {
    return (
      <Alert severity="warning">
        {lang?.adminStudioUnknownPage || "Unknown studio page."}
      </Alert>
    );
  }

  if (!hasStudioSession) {
    return null;
  }

  return (
    <Box sx={{ "& .MuiContainer-root": { maxWidth: "100% !important" } }}>
      <Page lang={lang} />
    </Box>
  );
}
